export default class Select {
  constructor(selector, options) {
    this.wrapper = selector;
    this.select = this.wrapper.querySelector('select');
    this.isActive = false;
    this.selectedIndex = 0;
    this.options = {
      prefix: 'pfx-',
      selectClass: 'select',
      toggleButtonClass: 'label',
      menuListClass: 'menu',
      menuItemClass: 'menu-item',
      isActiveClass: 'is-active',
      isSelectedClass: 'is-selected',
      ...options,
    };
    this.handleClick = this.handleClick.bind(this);
    this.documentClick = this.documentClick.bind(this);
    this.wrapper.select = this;
  }

  init() {
    if (this.wrapper.classList.contains('plugin-select-initialized')) return;
    this.createElements();
    this.addListeners();
    this.wrapper.classList.add('plugin-select-initialized');
  }

  getSelectedTextContent() {
    return this.select.options[this.select.selectedIndex].textContent;
  }

  setToggleButtonLabel() {
    this.toggleButton.textContent = this.getSelectedTextContent();
  }

  setItemSelect() {
    Array.from(this.menuList.childNodes).forEach((item) => {
      item.classList.remove(this.options.isSelectedClass);
    });

    Array.from(this.menuList.childNodes)[this.selectedIndex].classList.add(
      this.options.isSelectedClass,
    );
  }

  createToggleButton(textContent) {
    const toggleButton = document.createElement('span');
    toggleButton.classList.add(
      `${this.options.prefix}${this.options.selectClass}__${this.options.toggleButtonClass}`,
    );
    toggleButton.textContent = textContent;

    return toggleButton;
  }

  createMenuItem(textContent) {
    const menuItem = document.createElement('li');
    menuItem.classList.add(
      `${this.options.prefix}${this.options.selectClass}__${this.options.menuItemClass}`,
    );
    menuItem.textContent = textContent;

    return menuItem;
  }

  createMenuList() {
    const menuList = document.createElement('ul');
    menuList.classList.add(
      `${this.options.prefix}${this.options.selectClass}__${this.options.menuListClass}`,
    );

    if (this.select) {
      Array.from(this.select.options).forEach((option, index) => {
        const item = this.createMenuItem(option.textContent);
        menuList.appendChild(item);

        if (option.selected) {
          item.classList.add(this.options.isSelectedClass);
        }

        item.addEventListener('click', () => {
          this.selectedIndex = index;
          this.select.selectedIndex = index;
          this.select.dispatchEvent(new Event('change'));
        });
      });
    }

    return menuList;
  }

  createElements() {
    if (this.select) {
      this.select.style.display = 'none';
      this.toggleButton = this.createToggleButton(this.getSelectedTextContent());
      this.menuList = this.createMenuList();

      this.wrapper.insertBefore(this.toggleButton, this.select);
      this.wrapper.insertBefore(this.menuList, this.select);
    }
  }

  addListeners() {
    if (!this.select.disabled) {
      this.wrapper.addEventListener('click', this.handleClick);
      this.select.addEventListener('change', () => {
        this.setToggleButtonLabel();
        this.setItemSelect();
      });
    }
  }

  handleClick(event) {
    event.preventDefault();

    if (this.isActive) {
      this.close();
    } else {
      this.open();
    }
  }

  documentClick(event) {
    const clickInside = this.wrapper.contains(event.target);
    if (this.isActive && !clickInside) {
      this.close();
    }
  }

  open() {
    document.addEventListener('click', this.documentClick);
    this.wrapper.classList.add(this.options.isActiveClass);
    this.isActive = true;

    if (this.menuList) {
      this.menuList.style.visibility = 'hidden';
      this.menuList.style.top = '100%';
      this.menuList.style.bottom = 'auto';

      requestAnimationFrame(() => {
        const rect = this.menuList.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const menuHeight = this.menuList.offsetHeight;

        const spaceBelow = viewportHeight - rect.top - this.toggleButton.offsetHeight;
        const spaceAbove = rect.top;

        if (spaceBelow < menuHeight && spaceAbove > menuHeight) {
          this.menuList.style.top = 'auto';
          this.menuList.style.bottom = '100%';
        } else {
          this.menuList.style.top = '100%';
          this.menuList.style.bottom = 'auto';
        }

        this.menuList.style.visibility = 'visible';
      });
    }
  }

  close() {
    document.removeEventListener('click', this.documentClick);
    this.wrapper.classList.remove(this.options.isActiveClass);
    this.isActive = false;
  }

  getValue() {
    if (this.select) {
      return this.select.value;
    }

    return null;
  }

  updateOptions(options) {
    this.destroy();

    options.forEach((option) => {
      const newOption = document.createElement('option');
      newOption.value = option.value;
      newOption.textContent = option.label;

      this.select.appendChild(newOption);
    });

    this.init();
  }

  setDisabled(disabled) {
    if (disabled) {
      this.wrapper.classList.add('is-disabled');
      this.select.setAttribute('disabled', true);
      this.wrapper.removeEventListener('click', this.handleClick);

      this.close();
    } else {
      this.wrapper.classList.remove('is-disabled');
      this.select.removeAttribute('disabled');

      this.wrapper.addEventListener('click', this.handleClick);
    }
  }

  destroy() {
    this.wrapper.removeEventListener('click', this.handleClick);
    document.removeEventListener('click', this.documentClick);
    this.select.removeEventListener('change', this.setToggleButtonLabel);

    if (this.select) {
      this.select.options.length = 0;
    }

    if (this.menuList) {
      this.menuList.remove();
    }

    if (this.toggleButton) {
      this.toggleButton.remove();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const selectors = Array.from(document.querySelectorAll('.js-select'));
  selectors.forEach((selector) => {
    const customSelect = new Select(selector);

    customSelect.init();
  });
});
